<template>
  <div class="Target_info" align="" style="width:80%">
    <div v-if="data">
      <div class="title" :inline="true">
        <el-form >
          <el-form-item  :label="`${$t('TargetInfo.title')}`"  >          
          </el-form-item>
        </el-form>
      </div>
      <el-breadcrumb class="admin-path" separator="-" >
        <el-breadcrumb-item>
            <a  href="/">{{$t('navBar.goback')}}</a> 
        </el-breadcrumb-item>
        <!-- <el-breadcrumb-item :to="{ path: '/infoobs/'+data.id }">{{$t('ObsInfo.title')}}
            <router-link v-bind:to="`/infoobs/`+data.id">{{$t('ObsInfo.title')}}</router-link>
        </el-breadcrumb-item> -->
      </el-breadcrumb>
      <div class="container" v-if="data">
        <el-form :inline="true" :model="TargetInfoForm" class="search-form">

          <el-form-item  label="ID" v-if="false">
            <el-input size="mini" v-model="data.id" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>

          <el-form-item v-if="false" :label="$t('proposal.obs_id')">
            <el-input size="mini" v-model="data.obs_id" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>

          <el-form-item  v-if="false" :label="$t('proposal.schedule_id')">
            <el-input size="mini" v-model="data.schedule_id" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>

          <el-form-item  v-if="false" :label="$t('proposal.tstart')">
            <el-input size="mini" v-model="data.tstart" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.tsop')">
            <el-input size="mini" v-model="data.tsop" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.start_utc')">
            <el-input size="mini" v-model="data.start_utc" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.stop_utc')">
            <el-input size="mini" v-model="data.stop_utc" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.duration')">
            <el-input size="mini" v-model="data.duration" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.pre_slew')">
            <el-input size="mini" v-model="data.pre_slew" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.post_slew')">
            <el-input size="mini" v-model="data.post_slew" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item   :label="$t('proposal.target')">
            <el-input size="mini" v-model="data.target" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.obs_mode')">
            <el-input size="mini" v-model="data.obs_mode" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.data_mode')">
            <el-input size="mini" v-model="data.data_mode" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.proposal')">
            <el-input size="mini" v-model="data.proposal" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.observer')">
            <el-input size="mini" v-model="data.observer" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.ptype')">
            <el-input size="mini" v-model="data.ptype" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.status')">
            <el-input size="mini" v-model="data.status" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  :label="$t('proposal.ra')">
            <el-input size="mini" v-model="data.ra" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  :label="$t('proposal.dec')">
            <el-input size="mini" v-model="data.dec" autocomplete="off"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.speed')">
            <el-input size="mini" v-model="data.speed" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.interval')">
            <el-input size="mini" v-model="data.interval" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.radius')">
            <el-input size="mini" v-model="data.radius" autocomplete="off"  :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.offset')">
            <el-input size="mini" v-model="data.offset" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.owner')">
            <el-input size="mini" v-model="data.owner" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.isopen')">
            <el-input size="mini" v-model="data.isopen" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.archive_time')">
            <el-input size="mini" v-model="data.archive_time" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.release_time')">
            <el-input size="mini" v-model="data.release_time" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.open_time')">
            <el-input size="mini" v-model="data.open_time" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.l1_file_id')">
            <el-input size="mini" v-model="data.l1_file_id" autocomplete="off"  :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.l15_file_id')">
            <el-input size="mini" v-model="data.l15_file_id" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.l2_file_id')">
            <el-input size="mini" v-model="data.l2_file_id" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.create_time')">
            <el-input size="mini" v-model="data.create_time" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.create_by')">
            <el-input size="mini" v-model="data.create_by" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.update_time')">
            <el-input size="mini" v-model="data.update_time" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.update_by')">
            <el-input size="mini" v-model="data.update_by" autocomplete="off" :disabled="true" v-if="false"></el-input>
          </el-form-item>
      
      
        </el-form>

        <el-table :data="poplist" >
          <!-- <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column> -->

          <el-table-column
            prop="id"
            label="id"
            v-if="false">
          </el-table-column>  

          <el-table-column
            prop="obs_id"
            width="120"
            :label="$t('proposal.obs_id')">
            <template slot-scope="scope">
              <span :title="$t('proposal.tip.obs_id')" >
                <router-link v-bind:to="`/infoobs/`+scope.row.id">{{scope.row.obs_id}}</router-link>
                <!-- <a :href="`/infoobs/$t{'scope.row.id}`" target="_blank" class="buttonText">{{scope.row.obs_id}}</a> -->
              </span>
            </template>
      
          </el-table-column>

          <el-table-column
            prop="proposal"
            :label="$t('proposal.proposal')"
            v-if="false">
            <template slot-scope="scope">
              <span :title="$t('proposal.tip.proposal')">
                <router-link v-bind:to="`/infoproposal/`+scope.row.id">{{scope.row.proposal}}</router-link>
              </span>
            </template>
          </el-table-column>  
          <el-table-column
            :label="$t('proposal.ptype')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.ptype')">{{row.ptype}}</span>
            </template>
          </el-table-column> 


          <el-table-column
            prop="start_utc"
            :label="$t('proposal.start_utc')">
          </el-table-column>


          <el-table-column
            prop="stop_utc"
            :label="$t('proposal.stop_utc')">
          </el-table-column>

          <el-table-column
            prop="duration"
            :label="$t('proposal.duration')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.duration')">{{row.duration}}</span>
            </template>
          </el-table-column>




        </el-table>

        <div id="source_flux" style="width:100%; height:400px"></div>
        <el-table
          :data="list"
          style="width: 100%">
          <el-table-column
            prop="ind"
            label="ind"
            v-if="false">
          </el-table-column>
          <el-table-column
            prop="src_name"
            :label="$t('TargetInfo.src_name')">
          </el-table-column>
          <el-table-column
            prop="ra"
            label="ra">
          </el-table-column>
          <el-table-column
            prop="dec"
            label="dec">
          </el-table-column>
          <el-table-column
            prop="obs_id"
            :label="$t('TargetInfo.obs_id')">
          </el-table-column>
          <el-table-column
            prop="obs_time"
            :label="$t('TargetInfo.obs_time')"
            width="200px">
          </el-table-column>
          <el-table-column
            prop="duration"
            :label="$t('TargetInfo.duration')">
          </el-table-column>
          <el-table-column
            prop="flux_h"
            label="flux_h">
          </el-table-column>
          <el-table-column
            prop="flux_m"
            label="flux_m">
          </el-table-column>
          <el-table-column
            prop="flux_l"
            label="flux_l">
          </el-table-column>          
        </el-table>
        <div align="right">
          <!-- <el-button size="mini" @click="chiefverno" :disabled="true">拒绝(refuse)</el-button>
          <el-button size="mini" type="primary" @click="chiefverok" :disabled="true">同意(OK)</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as echarts from 'echarts';

var myChart;
export default {
  name: 'TargetInfo',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: null,
      list:[],
      TargetInfoForm:{
      },
      timeData : [],
      flux_h : [],
      flux_m : [],
      flux_l : [],
      poplist: [],
    };
  },
  created() {
    this.getData();
  },
 
  methods: {
    getData() {
      const params = {
        id : this.id,
      }
      
      axios.post('/iapi/InfoObs', params).then((res) => {
        if (res.data.errcode === 0) {
          this.data = res.data.data;
          // console.log('data',this.data);
          this.gettarobslist();
          this.getFluxData();
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    gettarobslist(){
      const params = {
        target : this.data.target,
      }
      
      axios.post('/iapi/tarobslist', params).then((res) => {
        if (res.data.errcode === 0) {
          this.poplist = res.data.data;

          // console.log('data',this.data);
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    getFluxData() {
      const params = {
        target : this.data.target,
      }
      
      axios.post('/iapi/getflux', params).then((res) => {
        if (res.data.errcode === 0) {
          this.list = res.data.data;
          this.handleData(this.list);
          this.initEcharts();
          // console.log('data',this.data);
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    handleData(data) {
        let timeData = [];
        let flux_h = [];
        let flux_m = [];
        let flux_l = [];

        for (let i = 0; i < data.length; i++) {
            timeData.push(data[i].obs_time);
            flux_h.push(data[i].flux_h);
            flux_m.push(data[i].flux_m);
            flux_l.push(data[i].flux_l);
        }

        this.timeData = timeData;
        this.flux_h = flux_h;
        this.flux_m = flux_m;
        this.flux_l = flux_l;

    },
    onSubmit() {
      this.getData();
    },

    initEcharts() {
      if(myChart) {
          myChart.dispose();
      }
      myChart = echarts.init(document.getElementById('source_flux'),'infographic');

      let option = {
          tooltip : {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  animation: false,
                  label: {
                      backgroundColor: '#505765'
                  }
              }
          },
          legend: {
              data:['flux_h','flux_m','flux_l']
          },
          toolbox: {
              feature: {
                  dataZoom: {
                      yAxisIndex: 'none'
                  },
                  dataView: {show: true, readOnly: false},
                  restore: {show: true},
                  saveAsImage: {show: true}
              }
          },
          axisPointer: {
              link: {xAxisIndex: 'all'}
          },
          dataZoom: [
              {
                  show: true,
                  realtime: true,
                  start: 0,
                  end: 100
              },
              {
              type: 'inside',
              show: true,
              realtime: true,
              start: 0,
              end: 100
          }],

          grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
          },
          xAxis : [
              {
                  type : 'category',
                  boundaryGap : false,
                  axisLine: {onZero: false},
                  data: this.timeData
              }            
          ],
          yAxis : [
            {                            
                type : 'value',
                name : 'y',
            }],
          series : [
            {
                name:'flux_h',
                type:'line',
                data:this.flux_h
            },
            {
                name:'flux_m',
                type:'line',
                // yAxisIndex: 1,
                data:this.flux_m
            },
            {
                name:'flux_l',
                type:'line',
                // yAxisIndex: 2,
                data: this.flux_l
            }
          ]
      };
      myChart.setOption(option);
      if (!this.timeData.length) {
        myChart.showLoading({
        text: '暂无数据',
        showSpinner: false,
        textColor: 'black',
        maskColor: 'rgba(255, 255, 255, 1)',
        fontSize: '26px',
        fontWeight: 'bold'
        })
        } else {
        myChart.hideLoading()
      }
    },
  },
};
</script>

<style scoped>

.Target_info{
  padding: 24px 56px;
  margin:0 auto;
}
.title {
  margin-right: 56px;
  font-size: 40px;
  color: #fff;
  font-weight: 50;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 5px;
    margin-bottom: 5px;
}
.admin-path {
  margin-bottom: 30px;
}
</style>
